module.exports = __webpack_public_path__ + "img/Show-N-Go-Icon.38ab10eb.svg";